import {Message} from "src/app/core/class/message";
import {Component, OnDestroy, OnInit, ViewChild} from "@angular/core";
import {MatDialog} from "@angular/material";
import {ActivatedRoute, Router} from "@angular/router";
import {ToastrService} from "ngx-toastr";
import {CommonService} from "src/app/core/services/common.service";
import {NotificationService} from "src/app/core/services/notification.service";
import {SelectDocumentTypeComponent} from "../../document/select-document-type/select-document-type.component";
import {DocumentTypeService} from "src/app/core/services/document-type.service";
import {DocumentTypeEnterprise} from "src/app/core/class/DocumentTypeEnterprise";
import {DocumentTemplateService} from "src/app/core/services/document-template.service";
import {ContractLotService} from "src/app/core/services/contract-lot.service";
import {ConfigSigningFlowMohaComponent} from "../config-signing-flow-moha/config-signing-flow-moha.component";
//import {SignatureConfigLotMohaComponent} from "../signature-config-lot-moha/signature-config-lot-moha.component";
import {ContractLotDigital} from "../../../../../../shared/models/contract-lot-digital";
import {TemplateFileService} from 'src/app/core/services/template-file.service';
import {DialogPreviewPdfComponent} from '../../document-management/dialog-preview-pdf/dialog-preview-pdf.component';
import {ProcessingService} from 'src/app/core/services/processing.service';
import {WarningComponent} from "src/app/shared/components/warning/warning.component";
import {Location} from "@angular/common";
import {ErrorCode} from "src/app/core/constants/error-code";
import {forkJoin, Subscription} from 'rxjs';
import {DocumentService} from 'src/app/core/services/document.service';
import {WarningDialogComponent} from 'src/app/modules/dashboard/home/home-enterprise/contract-lot/warning-dialog/warning-dialog.component';
import {LotType} from "src/app/core/constants/lot-type";
import {EnumRoleUser} from "src/app/core/constants/common"
import {CreateContractService} from "src/app/core/services/create-contract.service";
import { AutoEnterpriseService } from "src/app/core/services/auto-enterprise.service";
import { WarningSmsContractService } from "src/app/core/services/warning-sms-contract.service";
import { CreateContractMohaService } from "src/app/core/services/create-contract-moha.service";
import {ContractLot} from "../../../../../../shared/models/contract-lot";
import {BlockUI, NgBlockUI} from "ng-block-ui";

@Component({
  selector: "app-add-lot-moha-digital",
  templateUrl: "./add-lot-moha-digital.component.html",
  styleUrls: ["./add-lot-moha-digital.component.scss"],
})
export class AddLotMohaDigitalComponent implements OnInit, OnDestroy {
  @ViewChild('configSign', {static: false}) configSignComponent: ConfigSigningFlowMohaComponent;

  @ViewChild(ConfigSigningFlowMohaComponent, {
    read: ConfigSigningFlowMohaComponent,
    static: true
  }) configSigningFlowComponent: ConfigSigningFlowMohaComponent;

  @ViewChild('expansionData', {static: false}) expansionData: any;
  @BlockUI() blockUI: NgBlockUI;

  private readonly RUNNING_STATUSES = ['NEW', 'PROCESSING'];

  contractType: any = null;
  serviceType: any = null;
  listDigitalContract: any[] = [];
  current = 0;
  fileName: string = "";
  fileBase64: string = "";
  createSide: any = null;
  dataFootNote: any = null;

  contractLot: ContractLot = null;
  currentTab: number = 0;
  id: string = null;
  contractLotDigital: ContractLotDigital = null;
  contractDetailsList: any[] = [];
  isExpandResult: boolean = true;
  dynamicColumns: any = []
  tableData: any = []
  lotGroupColumns: { name: string; span: number }[] = [];
  lotGroupRowColumns: string[] = [];
  private EventWarningContractSubscription: Subscription;
  viewMode: 'create' | 'view' = 'create';

  processing: any = null;

  errorFile: boolean = false;

  isDragOver: boolean = false;
  subcription: Subscription = new Subscription();
  pollingInterval: any = null;

  userSign: string = null;

  checked = true;
  DATA_RECORD_USER_PERFORM_SIGN = [];
  checkFirtClick = true;
  public cecaEnable: boolean;
  isNotAttestedUser: boolean = false;

  dataUserSign: any = null;
  isBuyContract1Mb: boolean = false;
  isBuyContract10Mb: boolean = false;
  isHaveDeleteCreata: boolean = false;
  maxNumberOfCustomerInFlow: number = 1;
  public noteWarning = "";
  isContainCustomerSignature = false;

  pdfFileList: any[] = [];
  RECORD_SHARE_PARTNER = [];
  filteredPartyOptions: any = []
  timeOutQueryServer: any;
  inputPartyValue: string = ''
  nzCheckLoadingParty2 = false

  importFields: { idFileContract: string; fileName: string }[] = [];

  constructor(
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    public notificationService: NotificationService,
    private toast: ToastrService,
    public message: Message,
    private route: ActivatedRoute,
    private documentTypeService: DocumentTypeService,
    public documentTemplateService: DocumentTemplateService,
    public contractLotService: ContractLotService,
    public templateFileService: TemplateFileService,
    public processingService: ProcessingService,
    public location: Location,
    private createContractService: CreateContractService,
    public createContractMohaService: CreateContractMohaService,
    public documentService: DocumentService,
    public autoEnterpriseService: AutoEnterpriseService,
    private warningSmsContractService: WarningSmsContractService,
    ) {
    this.checked = true;
    this.isNotAttestedUser = this.commonService.checkEnterpriseType();
  }

  ngOnDestroy(): void {
    this.stopPolling();
    if (this.EventWarningContractSubscription) {
      this.EventWarningContractSubscription.unsubscribe();
    }
    this.subcription.unsubscribe();

    if (this.viewMode === 'create') {
      this.createContractService.recordsUserPerformSign.next([]);
    }
  }

  ngOnInit() {
    this.id = this.route.snapshot.params.id;
    this.cecaEnable = localStorage.getItem('cecaEnable') == 'true';

    if (this.id) {
      this.viewMode = 'view';

      // Chế độ view: xóa danh sách tạm để chỉ lấy từ API
      this.pdfFileList = [];
      this.createContractMohaService.listDigitalContractFiles.next([]);
      /**
       * Subscibe data queue emit from websocket
       */
       if (this.processing) {
        this.updateProcessing(this.contractLotDigital && this.contractLotDigital.status);
      }

      const proccesingTaskSub = this.processingService.processingTask.subscribe(ref => {
        const process = ref.find(item =>
          item.id.replace(/\=/g, '') === this.id.replace(/\=/g, '') &&
          item.type === LotType.CONTRACT_MOHA_LOT);
      
        if (process || this.processing) {
          this.refreshContractLot();
        }
      });

      this.subcription.add(proccesingTaskSub);

      // Gọi API lấy dữ liệu chi tiết lô ban đầu và kích hoạt polling nếu lô đang PROCESSING
      this.processing = { percent: 0 };
      this.refreshContractLot();
      this.startPolling();

      forkJoin([
        this.documentTypeService.getInfoProperties(null, false),
        this.contractLotService.getPropertiesContractLotById(this.id)
      ]).subscribe((res) => {
        if(!res[0].success){
          this.toast.error(res[0].message)
          return;
        }
        if(!res[1].success){
          this.toast.error(res[1].message)
          return;
        }
        this.dynamicColumns = res[0].data
          .filter(e => e.inputType !== "HEADER")
          .sort((first, second) => Number(first.order || 0) - Number(second.order || 0));
        this.buildGroupColumns(res[0].data);
        this.tableData = this.mapContractReportRows(res[1].data);

        // Fallback cho loại hợp đồng nếu API get-by-id không trả về
        if ((!this.contractType || !this.contractType.name) && res[1] && res[1].data && Array.isArray(res[1].data) && res[1].data.length > 0) {
          const firstRow = res[1].data[0];
          if (firstRow && firstRow.serviceTypeName) {
            this.contractType = {
              id: firstRow.serviceTypeId,
              name: firstRow.serviceTypeName,
              employmentContractTerm: firstRow.employmentContractTerm
            };
            this.serviceType = this.contractType;
            if (firstRow.serviceTypeId && !this.contractType.employmentContractTerm) {
              const enterpriseId = localStorage.getItem('enterpriseId');
              this.documentTypeService.getServiceTypesMoha(enterpriseId, true).subscribe(rs => {
                if (rs && rs.data) {
                  const found = rs.data.find((item: any) => item.id == firstRow.serviceTypeId);
                  if (found) {
                    this.contractType = {
                      ...found,
                      name: found.name,
                      employmentContractTerm: found.employmentContractTerm
                    };
                    this.serviceType = this.contractType;
                  }
                }
              });
            }
          }
        }

        console.log('[LotReport] res[0].data (get-all):', res[0].data);
        console.log('[LotReport] nhóm:', this.lotGroupColumns);
      })

      // Lấy danh sách file PDF đã tải lên
      this.getPdfFileList();   
    } else {
      // Chế độ tạo mới: lấy dữ liệu từ service đã lưu ở các bước trước
      this.viewMode = 'create';
      this.contractType = this.createContractMohaService.contractTypeDigital.value;
      this.serviceType = this.contractType;
      this.listDigitalContract = this.createContractMohaService.listDigitalContractFiles.getValue();

      if (!this.contractType) {
        // F5 trang thì service bị reset -> quay lại danh sách
        this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
        return;
      }
    }

    this.warningSmsContractService.getDataQuantityAndWarningQuantitySmsContractOfEnterpriseByService();
    this.EventWarningContractSubscription = this.warningSmsContractService.statusUpdated.subscribe(
      (response) => {
        this.isBuyContract1Mb = response.isBuyContract1Mb;
        this.isBuyContract10Mb = response.isBuyContract1Mb;
      }
    );
  }

  decodeId(id: string) {
    const idDecode = atob(id);
    const findNumber = idDecode.match(/[0-9]{1,}/g);
    if (findNumber && findNumber.length) {
      return Number(findNumber[findNumber.length - 1]);
    }
    return null;
  }

  uploadFile() {
    const inputFile = document.getElementById("file");
    inputFile.click();
  }

  async onChangeFile(event: any) {
    const temp = (<HTMLInputElement>document.getElementById("file")).files[0];
    const accept: RegExp = /\.(xlsx|xls)$/i;
    if (!accept.exec(temp.name)) {
      this.toast.error(
        this.message.getMessage("messages.error_file_type_excel")
      );
      return;
    }
    if (temp.size > 10000000) {
      this.toast.error(this.message.getMessage("messages.error_file_size"));
      return;
    }
    this.fileName = temp.name;
    this.fileBase64 = await this.getBase64(temp) as any;
  }

  deleteFile() {
    this.fileName = null;
    this.fileBase64 = null;
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = true;
  }

  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;
  }

  async onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragOver = false;

    const files = event.dataTransfer && event.dataTransfer.files;
    if (!files || files.length === 0) {
      return;
    }
    const temp = files[0];
    const accept: RegExp = /\.(xlsx|xls)$/i;
    if (!accept.exec(temp.name)) {
      this.toast.error(this.message.getMessage('messages.error_file_type_excel'));
      return;
    }
    if (temp.size > 10000000) {
      this.toast.error(this.message.getMessage('messages.error_file_size'));
      return;
    }
    this.fileName = temp.name;
    this.fileBase64 = await this.getBase64(temp) as any;
  }

  setMaxNumberOfPartner(value: number) {
    this.maxNumberOfCustomerInFlow = value;
    if (!this.maxNumberOfCustomerInFlow || this.maxNumberOfCustomerInFlow <= 0) {
      this.maxNumberOfCustomerInFlow = 1;
      this.isContainCustomerSignature = false;
    } else {
      this.isContainCustomerSignature = true;
    }
    this.noteWarning = this.commonService.format(this.message.getMessage('contract_lot.note_warning'), this.maxNumberOfCustomerInFlow)
  }

  downloadFileTemplate() {
    const uploadedFiles = this.createContractMohaService.listDigitalContractFiles.getValue();
  
    this.contractLotService.generateImportFileDigital({
      serviceTypeId: this.contractType.id,
      maxNumberOfPartner: this.maxNumberOfCustomerInFlow,
      uploadedFiles: uploadedFiles
    })
    .subscribe(res => {
      const prefix = this.message.getMessage('digital_lot.template_contract');
      this.downLoadFile(res, 'application/octet-stream', `${prefix} ${this.contractType.name}.xlsx`);
    });
  }

  downLoadFile(data: any, type: string, fileName: string) {
    const blob = new Blob([data], {type});
    if (window.top.navigator.msSaveOrOpenBlob) {
      // Store Blob in IE
      window.top.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      // Store Blob in others
      const tA = document.body.appendChild(document.createElement('a'));
      tA.href = URL.createObjectURL(blob);
      tA.download = fileName;
      tA.style.display = 'none';
      tA.click();
      tA.parentNode.removeChild(tA);
    }
  }

  async submit() {
    this.sortOrderApproveSign();
    this.errorFile = false;
    if (!this.fileBase64) {
      this.toast.error(this.message.getMessage('validation.error_not_have_file_lot'));
      return;
    }
    if (this.configSignComponent.validateErrorSetUser()) {
      this.expansionData.open();
      this.toast.error(this.message.getMessage('validation.error_user_no_set_up'));
      this.currentTab = 0;
      return;
    }

    if (this.dataFootNote) {
      this.dataFootNote.map((item, index) => {
        // nếu có 1 thằng khách hàng thôi thì map luôn chân ký cho thằng đầu tiên
        if (item.signature &&
          item.signature.object
          && item.signature.object === 'CUSTOMER' && this.maxNumberOfCustomerInFlow == 1) {
          item.customerOrder = 1;
        }
      });
    }

    this.standardizedData();
    const data: ContractLotDigital = ContractLotDigital.build();
    data.enterpriseSign = this.configSignComponent.RECORD_PARTY_SIGN;
    data.enterpriseSign.push({
      enterpriseId: "",
      order: 2,
      email: "",
      enterpriseName: "",
      certificateNo: "",
      customerId: "",
      isCreatedSide: false,
      isCreatedSideJoin: false,
      isSignNoLogin: false,
      name: "customer",
      phone: "",
      status: 1,
      useDataForTemplate: false
    });

      const source = this.configSignComponent.RECORD_USER_PERFORM_SIGN || [];
      data.userSign = source.map(item => ({
      ...item,
      signConfig: JSON.stringify(item.signConfig)
      }));
    if (this.createSide && this.configSignComponent.RECORD_USER_PERFORM_SIGN) {
      const userSignIndex = this.configSignComponent.RECORD_USER_PERFORM_SIGN.findIndex(item => item.role === EnumRoleUser.USER_SIGN);
      // Di chuyển userSign về cuối mảng
      if (userSignIndex != -1) {
        let userSign = this.configSignComponent.RECORD_USER_PERFORM_SIGN.splice(userSignIndex, 1)[0];
        this.configSignComponent.RECORD_USER_PERFORM_SIGN.push(userSign);
      }
      // Cập nhật lại order cho các phần tử khác trong mảng
      for (let i = 0; i < this.configSignComponent.RECORD_USER_PERFORM_SIGN.length; i++) {
        this.configSignComponent.RECORD_USER_PERFORM_SIGN[i].order = i + 1;
      }
    }
    data.importFileBase64 = this.fileBase64.replace('data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,', '');
    data.importFileName = this.fileName;
    data.serviceTypeId = (this.contractType ? this.contractType.id : null);

    data.maxPartnerNumber = this.maxNumberOfCustomerInFlow;
    data.contractSharePartners = this.RECORD_SHARE_PARTNER
    const uploadedFiles = this.createContractMohaService.listDigitalContractFiles.getValue() || [];
    data.importFields = uploadedFiles.map(f => ({
    idFileContract: f.idFileContract,
    fileName: f.fileName
    }));
    this.contractLotService.createContractLotDigital(data).subscribe(res => {
      if (!res || !res.data) {
        if (res.message) {
          this.toast.error(res.message);
        }
        if (res.code === ErrorCode.FormatImportCustomerExcel || res.code === ErrorCode.EmptyImportCustomerExcel) {
          this.errorFile = true;
          setTimeout(() => {
            const element = document.getElementsByClassName('error-file');
            element.item(0).scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
          })
        }
        return;
      }
      this.createContractMohaService.listDigitalContractFiles.next([]);
      this.contractLotService.processingStart.next(true);
      this.blockUI.reset();
      this.blockUI.start();
      setTimeout(() => {
        this.router.navigateByUrl(`/home-enterprise/contract-digital-add-lot/add-lot/${res.data}`);
        this.blockUI.stop();
      }, 5000);   
    })
  }


  genSignature(id: string, users: any) {
    this.documentTemplateService.getSignature(id).subscribe(res => {
      if (!res || !res.data) {
        return;
      }
      const enterprise = users.find(item => item.isCreatedSide);
      this.createSide = enterprise;
      let filled = false;
      this.dataFootNote = res.data.map(item => {
        if (item.signature) {
          const page = [];
          if (item.signature.positions) {
            item.signature.positions.forEach(pos => {
              if (pos.page && !page.includes(pos.page)) {
                page.push(pos.page);
              }
            });
          }
          item.signature.page = page.join(', ');
          if (item.signature.object && item.signature.object !== 'ENTERPRISE' && item.signature.object !== 'ENTERPRISEAPPROVER' && !filled) {
            item.customer = true;
            filled = true;
          } else {
            item.customer = false;
          }
        }
        return item;
      });
      // đếm số lượng chân ký của khách hàng trong mẫu
      let lsCustomerSignature = res.data.filter(item => {
        if (item.signature
          && item.signature.object
          && item.signature.object !== 'ENTERPRISE'
          && item.signature.object !== 'ENTERPRISEAPPROVER') {
          return true;
        } else {
          return false;
        }
      });

      this.maxNumberOfCustomerInFlow = lsCustomerSignature.length;
      if (!this.maxNumberOfCustomerInFlow || this.maxNumberOfCustomerInFlow <= 0) {
        this.maxNumberOfCustomerInFlow = 1;
        this.isContainCustomerSignature = false;
      } else {
        this.isContainCustomerSignature = true;
      }
      this.noteWarning = this.commonService.format(this.message.getMessage('contract_lot.note_warning'), this.maxNumberOfCustomerInFlow);
      // nếu có 1 thằng khách hàng thôi thì map luôn chân ký cho thằng đầu tiên
    });
  }

  getDefault(event: any) {
    this.genSignature((this.contractType ? this.contractType.id : null), event);
  }

  useCreateSide(event: any) {
    this.createSide = event;
  }

  openTabSign(event) {
    if (event.index === 1) {
      const isCreateSide = this.configSignComponent.RECORD_PARTY_SIGN.filter(item => item.isCreatedSide == true)
      if (isCreateSide.length > 0) {
        this.isHaveDeleteCreata = false;
      } else {
        this.isHaveDeleteCreata = true;
      }
    }
    if (event.index === 1) {
      this.DATA_RECORD_USER_PERFORM_SIGN = this.configSignComponent.RECORD_USER_PERFORM_SIGN.filter((item) => item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && (item && item.signConfig && item.signConfig.showImage));
    }
    if (event.index === 1 && this.checkFirtClick) {
      const listUserApprove = this.configSignComponent.RECORD_USER_PERFORM_SIGN;
      let indexApprover = 0;
      const approver = listUserApprove.filter(item => {
        return item.role === EnumRoleUser.USER_APPROVER && item.isSignDigitalCertificate && (item && item.signConfig && item.signConfig.showImage);
      });
      this.dataFootNote.map(item => {
        if (item.signature) {
          const page = [];
          if (item.signature.positions) {
            item.signature.positions.forEach(position => {
              if (position.page && !page.includes(position.page)) {
                page.push(position.page);
              }
            });
          }
          item.signature.page = page.join(', ');
          if (item.signature.object && item.signature.object === 'ENTERPRISEAPPROVER' && this.viewMode !== 'view') {
            item.userId = approver && approver[indexApprover] && approver[indexApprover].userId ? approver[indexApprover].userId : null;
            indexApprover++;
          }
        }
      });
      this.checkFirtClick = false;
    }
  }

  getBase64(file) {
    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }


  renderStatus(status: string) {
    switch (status) {
      case 'ERROR':
      case 'FAILD':
        return this.message.getMessage('contract_lot.status.error');
      case 'PROCESSING':
        return this.message.getMessage('contract_lot.status.processing');
      case 'DONE':
      case 'SUCCESS':
        return this.message.getMessage('contract_lot.status.done');
      default:
        return status || '';
    }
  }

  renderStatusColor(status: string): object {
    switch (status) {
      case 'ERROR':
        return {'color': 'red'};
      case 'PROCESSING':
        return {'color': 'blue'};
      default:
        return {'color': 'green'};
    }
  }

  renderNumber(type: 'total' | 'success' | 'error') {
    const list = (this.contractDetailsList && this.contractDetailsList.length > 0)
      ? this.contractDetailsList
      : (this.contractLot && this.contractLot.contractDetails ? this.contractLot.contractDetails : []);

    if (list && list.length > 0) {
      switch (type) {
        case 'total':
          return list.length;
        case 'error':
          return list.filter(item => {
            return item && (item.status === 'ERROR' || item.status === 'FAILD');
          }).length;
        case 'success':
          return list.filter(item => {
            return item && (item.status === 'DONE' || item.status === 'SUCCESS');
          }).length;
      }
    }
    return 0;
  }


  getResultFile() {
    this.contractLotService.getResultFile(this.id).subscribe(res => {
      this.downLoadFile(res, 'application/octet-stream', this.contractLotDigital.code ? this.contractLotDigital.code + '_ketqua.xlsx' : 'ketqua.xlsx');
    })
  }

  onClickCancel() {
    if (this.configSignComponent.isFormChanging || this.fileName) {
      const confirmDialog = this.dialog.open(WarningComponent, {
        width: '40%',
        data: this.message.getMessage('messages.cancel_create_contract_lot')
      });
      confirmDialog.afterClosed().subscribe(ref => {
        if (ref) {
          this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
        }
      });
      return;
    }
    this.router.navigateByUrl('/home-enterprise/contract-digitzation-moha');
  }

  setUserSign(name: string) {
    this.userSign = name;
  }

  setDataRecordUserPerformSign(event) {
    this.DATA_RECORD_USER_PERFORM_SIGN = event;
  }

  private standardizedData() {
    // Reorder party list
    this.configSignComponent.RECORD_PARTY_SIGN.sort((a, b) => (a.order - b.order));
    let nextOrder = 1;
    let currentOrder = this.configSignComponent.RECORD_PARTY_SIGN[0].order;
    this.configSignComponent.RECORD_PARTY_SIGN[0].order = 1;
    this.configSignComponent.RECORD_PARTY_SIGN.forEach((item) => {
      if (item.order > currentOrder) {
        nextOrder += 1;
        currentOrder = item.order;
      }
      item.order = nextOrder;
    });

    // Kiểm tra danh sách bên ký kết có bên Lập không
    // Nếu ko có >> xóa trắng danh sách người dùng ký kết
    const existedList = this.configSignComponent.RECORD_PARTY_SIGN.filter((e) => {
      return e.isCreatedSide === true && e.isCreatedSideJoin;
    });

    if (existedList.length <= 0) {
      this.configSignComponent.RECORD_USER_PERFORM_SIGN = [];
      this.configSignComponent.RECORD_PARTY_SIGN.forEach(item => {
        if (!item.isCreatedSide) {
          item.order = 1;
        } else {
          item.order = 0;
        }
      });
    }
  }

  sortOrderApproveSign() {
    let newOrder = 0;
    let RECORD_USER_APPROVE = [...this.configSignComponent.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_APPROVER)];
    let RECORD_USER_SIGN = [...this.configSignComponent.RECORD_USER_PERFORM_SIGN.filter(item => item.role === EnumRoleUser.USER_SIGN)];

    if (RECORD_USER_APPROVE.length) {
      RECORD_USER_APPROVE.sort((a, b) => {
        return a.order - b.order;
      });

      RECORD_USER_APPROVE = RECORD_USER_APPROVE.map((item, index) => {
        if (index === 0) {
          newOrder = 1;
          return {
            ...item,
            order: 1
          }
        } else {
          if (item.order !== RECORD_USER_APPROVE[index - 1].order) {
            newOrder++;
          }
          return {
            ...item,
            order: newOrder
          }
        }
      });

      RECORD_USER_SIGN = RECORD_USER_SIGN.map((item) => ({
        ...item,
        order: RECORD_USER_APPROVE[RECORD_USER_APPROVE.length - 1].order + 1
      }))
    }

    const RECORD_USER_PERFORM_SIGN = RECORD_USER_APPROVE.concat(RECORD_USER_SIGN);

    this.configSignComponent.RECORD_USER_PERFORM_SIGN = RECORD_USER_PERFORM_SIGN;
  }
  
  onChangePartySignSearch($event: any): void {
    this.filteredPartyOptions = [];
    if ($event.inputType.includes('insert') || $event.inputType.includes('delete')) {
      if (this.timeOutQueryServer) {
        clearTimeout(this.timeOutQueryServer);
      }
      this.timeOutQueryServer = setTimeout(() => {
        if (this.inputPartyValue.trim().length > 0) {
          this.nzCheckLoadingParty2 = true;
          this.autoEnterpriseService.fetchAuto(this.inputPartyValue.trim())
            .then(result => {
              this.filteredPartyOptions = [];
              if (result) {
                for (const item of result) {
                  if (!item.isCreatedSide) {
                     if (!this.checkExistedParty(item.enterpriseId, item.customerId)) {
                      const existedList = this.filteredPartyOptions.filter((e) => {
                        return e.enterpriseId === item.enterpriseId;
                      });
                      this.filteredPartyOptions.push(item);
                    }
                  } 
                }
              }
            }).finally(() => {
              this.nzCheckLoadingParty2 = false;
            });
        } else {
          this.inputPartyValue = '';
        }
      }, 500);

    }
  }
  autocompletePartySelected($event: any, model: any) {
    if ($event.isUserInput) {
      if (!this.checkExistedParty(model.enterpriseId, model.customerId)) {
        this.RECORD_SHARE_PARTNER = [
          ...this.RECORD_SHARE_PARTNER,
          {
            enterpriseId: model.enterpriseId,
            customerId: model.customerId,
            email: model.email,
            name: model.name,
            phone: model.phone,
            permission: 'FILE'
          }
        ];
        this.inputPartyValue = '';
        this.filteredPartyOptions = [];
      } else {
        this.toast.error(this.commonService.format(this.message.getMessage('messages.add_party_apostrophe_duplicate'), model.name));
      }
    }
  }
  checkExistedParty(enterpriseId: string, customerId: string) {
    const existedList = this.RECORD_SHARE_PARTNER.filter((e) => {
      return enterpriseId ? e.enterpriseId === enterpriseId : e.customerId === customerId;
    });

    return (existedList.length > 0);
  }
  onClickDeleteElementRecordParty(enterpriseId: any, customerId:any): void {
    if (enterpriseId && enterpriseId.length > 0) {
      this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.enterpriseId !== enterpriseId);
    } else {
      this.RECORD_SHARE_PARTNER = this.RECORD_SHARE_PARTNER.filter(d => d.customerId !== customerId);
    }
  }

  private mapContractReportRows(rows: any[]): any[] {
    return (rows || []).map(row => {
      const fieldsByKey = new Map<string, any>();
      // Hỗ trợ cả 2 tên để tránh lệch giữa Moha và Digital
      const fields = row.contractMohaFields || row.contractDigitalFields || [];
      fields.forEach(field => {
        fieldsByKey.set(field.key, field);
      });
  
      const reportFields = this.dynamicColumns.map(column => {
        const field = fieldsByKey.get(column.code);
        return {
          ...column,
          key: column.code,
          value: field ? field.value : null
        };
      });
  
      return {
        ...row,
        reportFields
      };
    });
  }

  handleContractLotData(data: any) {
    if (!data) {
      return;
    }
    this.contractLotDigital = data;
    this.contractLot = data;

    // 1. Số người trong luồng ký
    this.maxNumberOfCustomerInFlow = data.maxNumberOfPartner || data.maxNumberOfCustomerInFlow || 1;
    this.setMaxNumberOfPartner(this.maxNumberOfCustomerInFlow);

    // 2. Tên file import Excel (ưu tiên importFileName theo đúng chuẩn)
    this.fileName = data.importFileName || null;

    // 3. Bên ký kết và người ký
    if (data.enterpriseSign) {
      this.createSide = data.enterpriseSign.find((item: any) => item.isCreatedSide && item.isCreatedSideJoin);
      if (this.createSide && data.userSign) {
        const userSign = data.userSign.find((item: any) => item.role === 1 || item.role === EnumRoleUser.USER_SIGN);
        this.userSign = userSign && userSign.name ? userSign.name : null;
      }
    }
    this.DATA_RECORD_USER_PERFORM_SIGN = data.userSign || [];

    // 4. Đối tác chia sẻ
    if (data.contractSharePartners) {
      this.RECORD_SHARE_PARTNER = data.contractSharePartners.map((item: any) => ({
        ...item,
        email: item.receiveEmail,
        name: item.receiveName,
        phone: item.receivePhone,
      }));
    }

    // 5. Danh sách hợp đồng: lấy thẳng từ contractDetails
this.contractDetailsList = Array.isArray(data.contractDetails) ? data.contractDetails : [];
this.contractLot.contractDetails = this.contractDetailsList;
this.contractLotDigital.contractDetails = this.contractDetailsList;

// Danh sách file PDF: lấy từ contractAttachment
if (Array.isArray(data.contractAttachment) && data.contractAttachment.length > 0) {
  this.pdfFileList = data.contractAttachment.map((file: any) => ({
    ...file,
    fileName: file.fileName || file.name,
    status: file.status || file.uploadStatus || 'SUCCESS'
  }));
}

    // 6. Lấy thông tin loại hợp đồng từ API
    this.resolveContractTypeFromApi(data);
  }

  resolveContractTypeFromApi(data: any, documentType?: any) {
    // Ưu tiên: dữ liệu loại hợp đồng trả về từ API findById (name, employmentContractTerm)
    if (documentType && documentType.name) {
      this.contractType = {
        ...(this.contractType || {}),
        id: documentType.id,
        name: documentType.name,
        code: documentType.code,
        isEmploymentContract: documentType.isEmploymentContract,
        employmentContractTerm: documentType.employmentContractTerm
      };
      this.serviceType = this.contractType;
    } else if (data.serviceType && typeof data.serviceType === 'object') {
      this.contractType = data.serviceType;
      this.serviceType = this.contractType;
    } else if (data.contractType && typeof data.contractType === 'object') {
      this.contractType = data.contractType;
      this.serviceType = this.contractType;
    } else if (data.serviceTypeName || data.contractTypeName) {
      this.contractType = {
        id: data.serviceTypeId,
        name: data.serviceTypeName || data.contractTypeName,
        employmentContractTerm: data.employmentContractTerm
      };
      this.serviceType = this.contractType;
    }
  
    if (data.employmentContractTerm && this.contractType && !this.contractType.employmentContractTerm) {
      this.contractType.employmentContractTerm = data.employmentContractTerm;
    }
  
    const serviceTypeId = data.serviceTypeId || (typeof data.serviceType === 'number' ? data.serviceType : null);
    if (serviceTypeId && (!this.contractType || !this.contractType.name || !this.contractType.employmentContractTerm)) {
      const enterpriseId = localStorage.getItem('enterpriseId');
      this.documentTypeService.getServiceTypesMoha(enterpriseId, true).subscribe(rs => {
        if (rs && rs.data) {
          const found = rs.data.find((item: any) => item.id == serviceTypeId);
          if (found) {
            const currentName = (this.contractType && this.contractType.name) ? this.contractType.name : found.name;
            const currentTerm = (this.contractType && this.contractType.employmentContractTerm) ? this.contractType.employmentContractTerm : found.employmentContractTerm;
            this.contractType = {
              ...found,
              name: currentName,
              employmentContractTerm: currentTerm
            };
            this.serviceType = this.contractType;
          }
        }
      });
    }
  
    // Fallback: Nếu API chưa trả về trường loại hợp đồng, lấy từ service lưu trước đó
    if (!this.contractType) {
      const savedType = this.createContractMohaService.contractTypeDigital.value;
      if (savedType) {
        this.contractType = savedType;
        this.serviceType = this.contractType;
      }
    }
  }

  startPolling() {
    this.stopPolling();
    this.pollingInterval = setInterval(() => {
      this.refreshContractLot();
    }, 3000);
  }

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
      this.pollingInterval = null;
    }
  }

  refreshContractLot() {
    this.contractLotService.getContractLotById(this.id).subscribe(res => {
      if (!res || !res.data) { return; }
      this.handleContractLotData(res.data);
      this.updateProcessing(res.data.status);
    });
  }

  renderPercent() {
    const total = this.renderNumber('total');
    if (!total || total === 0) {
      return 0;
    }
    const percent = Math.round((this.renderNumber('error') + this.renderNumber('success')) / total * 100);
    return percent ? percent : 0;
  }

  getPdfFileList(): void {
    if (this.pdfFileList && this.pdfFileList.length > 0) {
      return;
    }
    if (this.contractLotDigital) {
      const files = this.contractLotDigital.uploadedFiles || this.contractLotDigital.pdfFileList || this.contractLotDigital.pdfFiles || this.contractLotDigital.contractFiles || this.contractLotDigital.fileDetails;
      if (files && Array.isArray(files) && files.length > 0) {
        this.pdfFileList = files.map((file: any) => ({
          ...file,
          status: file.status || file.uploadStatus || 'SUCCESS'
        }));
        return;
      }
    }
    if (!this.pdfFileList || this.pdfFileList.length === 0) {
      const serviceFiles = this.createContractMohaService.listDigitalContractFiles.getValue();
      if (serviceFiles && serviceFiles.length > 0) {
        this.pdfFileList = serviceFiles.map((file: any) => ({
          ...file,
          status: file.status || file.uploadStatus || 'SUCCESS'
        }));
      }
    }
  }

  // Gom cột động theo tên cha gần nhất (các section trùng tên gộp chung 1 nhóm),
  // giống bảng lịch sử tiêu chí ở màn chi tiết
  buildGroupColumns(dataStandard: any[]) {
    const fieldByCode = new Map<string, any>();
    (dataStandard || []).forEach(f => {
      if (f.code && !fieldByCode.has(f.code)) fieldByCode.set(f.code, f);
    });

    const groupNameOf = (f: any): string => {
      const parent = f.parentCode ? fieldByCode.get(f.parentCode) : null;
      return parent ? String(parent.name || parent.code || '').trim() : '';
    };

    const groupOrder: string[] = [];
    const buckets = new Map<string, any[]>();
    this.dynamicColumns.forEach((f: any) => {
      const g = groupNameOf(f);
      let bucket = buckets.get(g);
      if (!bucket) {
        bucket = [];
        buckets.set(g, bucket);
        groupOrder.push(g);
      }
      bucket.push(f);
    });
    const orderedColumns: any[] = [];
    groupOrder.forEach(g => orderedColumns.push(...(buckets.get(g) || [])));
    this.dynamicColumns = orderedColumns;

    this.lotGroupColumns = [];
    this.lotGroupRowColumns = [];
    orderedColumns.forEach(f => {
      const g = groupNameOf(f);
      const last = this.lotGroupColumns[this.lotGroupColumns.length - 1];
      if (g && last && last.name === g) {
        last.span++;
      } else {
        this.lotGroupColumns.push({ name: g, span: 1 });
        this.lotGroupRowColumns.push('lot_group_' + (this.lotGroupColumns.length - 1));
      }
    });
  }

  private updateProcessing(status?: string) {
    // Lô đã xong (khác NEW và PROCESSING) -> tắt thanh, dừng polling
    if (!this.isRunning(status)) {
      this.processing = null;
      this.stopPolling();
      return;
    }
    this.processing = { percent: this.renderPercent() };
  }

  private isRunning(status?: string): boolean {
    return !status || this.RUNNING_STATUSES.includes(status);
  }
}
